/**
 * Удобные алиасы типов актуального OpenAPI-контракта из sibling-пакета nbr-api.
 */
import type { components, paths } from "@nbr/api-types"

export type { paths, components }

export type Schemas = components["schemas"]

type SchemaOf<K extends string, Fallback> = K extends keyof Schemas ? Schemas[K] : Fallback

export type EntityType = Schemas["EntityType"]
export type SearchableType = Schemas["SearchableType"]
export type ExportFormat = Schemas["ExportFormat"]
export type EntityRef = Schemas["EntityRef"]
export type EntitySummary = Schemas["EntitySummary"]
export type EntityCard = Schemas["EntityCard"]
export type EntityWrite = Schemas["EntityWrite"]
export type EntityMeta = Schemas["EntityMeta"]
export type Nomen = Schemas["Nomen"]
export type NomenWrite = Schemas["NomenWrite"]
export type Identifier = Schemas["Identifier"]
export type IdentifierWrite = Schemas["IdentifierWrite"]
export type Relation = Schemas["Relation"]
export type RelationWrite = Schemas["RelationWrite"]
export type RelationGroup = Schemas["RelationGroup"]
/** Поля SearchHit, которые веб уже использует, а контракт nbr-api@main может ещё не содержать. */
type SearchHitExtras = {
  /** Член Союза писателей (для type=person) */
  union_member?: boolean
}
export type SearchHit = Schemas["SearchHit"] & SearchHitExtras
export type Facet = Schemas["Facet"]
export type FacetValue = Schemas["FacetValue"]
export type FacetName = Facet["name"]
export type Stats = Schemas["Stats"]
export type Citation = Schemas["Citation"]
export type MarcView = Schemas["MarcView"]
export type MarcField = Schemas["MarcField"]
export type RecommendationGroup = Schemas["RecommendationGroup"]
export type ContentPage = Schemas["ContentPage"]
export type ErrorReport = Schemas["ErrorReport"]
export type ErrorReportCreate = Schemas["ErrorReportCreate"]
export type ErrorReportStatus = Schemas["ErrorReportStatus"]
export type UserProfile = Schemas["UserProfile"]
export type UserRole = Schemas["Role"]
export type Workspace = Schemas["Workspace"]
export type WorkspaceId = Schemas["WorkspaceId"]
/**
 * Части ФИО анкеты писателя (nbr-api 035).
 * Optional в intersection: ответ старого @nbr/api-types без полей остаётся assignable;
 * на актуальном main поля уже required в Schemas и остаются required.
 */
type WriterProfileNameParts = {
  last_name?: string
  first_name?: string
  patronymic?: string | null
}
export type WriterProfile = Schemas["WriterProfile"] & WriterProfileNameParts
/** Тело PUT /me/writer-profile: части имени вместо display_name. */
export type WriterProfileWrite = Omit<Schemas["WriterProfileWrite"], "display_name"> & {
  last_name: string
  first_name: string
  patronymic?: string | null
}
/** Портфолио в публичной карточке (verified works). */
export type PublicWriterWork = SchemaOf<"PublicWriterWork", { id: string; title: string }>
/** Поля PublicWriterCard, которые веб уже использует до обновления nbr-api@main. */
type PublicWriterCardExtras = {
  works?: PublicWriterWork[]
}
export type PublicWriterCard = Schemas["PublicWriterCard"] & PublicWriterCardExtras
export type UnionApplication = Schemas["UnionApplication"]
export type WriterWork = Schemas["WriterWork"]
export type WriterAward = Schemas["WriterAward"]
/** Кабинеты аккаунта (nbr-api 027); fallback пока контракт не в nbr-api@main. */
export type AccountCabinets = SchemaOf<
  "AccountCabinets",
  {
    reader: boolean
    writer: boolean
    union: boolean
    organizer: boolean
    catalog: boolean
    administrator: boolean
  }
>
export type CabinetsAssignment = SchemaOf<
  "CabinetsAssignment",
  {
    reader: boolean
    writer: boolean
    union: boolean
    organizer: boolean
    catalog: boolean
    administrator: boolean
  }
>
export type ReplaceCabinetsRequest = SchemaOf<"ReplaceCabinetsRequest", { cabinets: CabinetsAssignment }>
/** Поля Account, которые веб уже использует до обновления nbr-api@main. */
type AccountExtras = {
  cabinets?: AccountCabinets
}
export type Account = Schemas["Account"] & AccountExtras
export type AccountStatus = Schemas["AccountStatus"]
export type AccessTokenResponse = Schemas["AccessTokenResponse"]
export type RegisterRequest = Schemas["RegisterRequest"]
export type LoginRequest = Schemas["LoginRequest"]
export type ForgotPasswordRequest = Schemas["ForgotPasswordRequest"]
export type ResetPasswordRequest = Schemas["ResetPasswordRequest"]
export type ChangePasswordRequest = Schemas["ChangePasswordRequest"]
export type ReplaceRolesRequest = Schemas["ReplaceRolesRequest"]
export type AccountPatch = Schemas["AccountPatch"]
export type Collection = Schemas["Collection"]
export type CollectionCreate = Schemas["CollectionCreate"]
export type CollectionDetail = Schemas["CollectionDetail"]
export type SavedQuery = Schemas["SavedQuery"]
export type SavedQueryCreate = Schemas["SavedQueryCreate"]
export type DuplicateCandidate = Schemas["DuplicateCandidate"]
export type EntityMatch = Schemas["EntityMatch"]
export type EditionWrite = Schemas["EditionWrite"]
export type EntityRefOrWrite = Schemas["EntityRefOrWrite"]
export type EditionCreator = Schemas["EditionCreator"]
export type Dictionaries = Schemas["Dictionaries"]
export type LabeledCode = Schemas["LabeledCode"]
export type IdentifierSchemeInfo = Schemas["IdentifierSchemeInfo"]
export type RelationTypeInfo = Schemas["RelationTypeInfo"]
export type AttributeInfo = Schemas["AttributeInfo"]
export type ImportJob = Schemas["ImportJob"]
export type AuditEntry = Schemas["AuditEntry"]
export type Problem = Schemas["Problem"]
export type Source = Schemas["Source"]

export type SearchQuery = NonNullable<paths["/search"]["get"]["parameters"]["query"]> & {
  group?: "work"
}
export type SearchSort = NonNullable<SearchQuery["sort"]>
export type SearchCluster = SchemaOf<
  "SearchCluster",
  {
    work?: SearchHit
    editions: SearchHit[]
    orphan: boolean
  }
>
export type EntityContext = SchemaOf<
  "EntityContext",
  {
    work?: EntityRef
    expression?: EntityRef
    sibling_manifestations: EntityRef[]
    orphan: boolean
  }
>
export type SearchResponse = Schemas["SearchResponse"] & {
  clusters?: SearchCluster[]
  related?: SearchHit[]
}
export type AdminEntitiesQuery = NonNullable<paths["/admin/entities"]["get"]["parameters"]["query"]>
export type AdminEntitiesSort = NonNullable<AdminEntitiesQuery["sort"]>
export type NbrOldItem = Schemas["NbrOldItem"]
export type NbrOldType = NbrOldItem["type"]
export type AdminNbrOldQuery = NonNullable<paths["/admin/nbr-old"]["get"]["parameters"]["query"]>
export type NbrOldList = {
  items: NbrOldItem[]
  total: number
  page: number
}
export type NbrOldField = NonNullable<AdminNbrOldQuery["field"]>
export type NbrOldRole = Schemas["NbrOldRole"]
export type NbrOldPerson = Schemas["NbrOldPerson"]
export type NbrOldSuggestion = Schemas["NbrOldSuggestion"]
export type AdminNbrOldSuggestQuery = paths["/admin/nbr-old/suggest"]["get"]["parameters"]["query"]
export type AdminAccountsQuery = NonNullable<paths["/admin/accounts"]["get"]["parameters"]["query"]>
export type CitationStyle = NonNullable<
  NonNullable<paths["/{type}/{id}/citation"]["get"]["parameters"]["query"]>["style"]
>

/** Результат SPARQL SELECT в формате application/sparql-results+json. */
export type SparqlBinding = { type: "uri" | "literal" | "bnode"; value: string; "xml:lang"?: string; datatype?: string }
export type SparqlResults = {
  head: { vars: string[] }
  results?: { bindings: Array<Record<string, SparqlBinding>> }
  boolean?: boolean
}

export const ENTITY_TYPES: EntityType[] = [
  "work",
  "expression",
  "manifestation",
  "item",
  "person",
  "collective_agent",
  "nomen",
  "place",
  "concept",
  "prize",
  "prize_season",
]

export const SEARCHABLE_TYPES: SearchableType[] = ["person", "work", "manifestation", "collective_agent", "concept", "prize"]

/** Типы, для которых есть публичная карточка `/{type}/:id`. */
export const CARD_TYPES: EntityType[] = ["person", "work", "manifestation", "collective_agent", "concept", "prize", "prize_season"]

export const isEntityType = (value: string | undefined | null): value is EntityType =>
  Boolean(value) && (ENTITY_TYPES as string[]).includes(value as string)

export const isSearchableType = (value: string | undefined | null): value is SearchableType =>
  Boolean(value) && (SEARCHABLE_TYPES as string[]).includes(value as string)
